import { Box, Typography } from '@mui/material';

const formatCurrency = (value: number) => `₩${Math.round(value).toLocaleString('ko-KR')}`;

type SummaryData = {
  totalRevenue: number;
  totalCost: number;
  totalProfit: number;
  profitMargin: number;
};

type Props = {
  data: SummaryData;
};

export default function ProfitLossSummaryCards({ data }: Props) {
  const { totalRevenue, totalCost, totalProfit, profitMargin } = data;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(4, 1fr)',
        },
        gap: 2,
        mt: 3,
      }}
    >
      {/* 총 매출 */}
      <Box
        sx={{
          backgroundColor: '#f5f5f5',
          border: '1px solid #e0e0e0',
          borderRadius: 2,
          p: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 'bold' }}>
          총 매출
        </Typography>
        <Typography variant="h6" fontWeight="bold">
          {formatCurrency(totalRevenue)}
        </Typography>
      </Box>

      {/* 총 비용 */}
      <Box
        sx={{
          backgroundColor: '#424242',
          border: '1px solid #e0e0e0',
          borderRadius: 2,
          p: 2,
          color: '#fff',
        }}
      >
        <Typography variant="body2" sx={{ mb: 1, color: 'rgba(255, 255, 255, 0.7)', fontWeight: 'bold' }}>
          총 비용
        </Typography>
        <Typography variant="h6" fontWeight="bold" color="#fff">
          {formatCurrency(totalCost)}
        </Typography>
      </Box>

      {/* 순수익 */}
      <Box
        sx={{
          backgroundColor: '#4CAF50',
          border: '1px solid #e0e0e0',
          borderRadius: 2,
          p: 2,
          color: '#fff',
        }}
      >
        <Typography variant="body2" sx={{ mb: 1, color: 'rgba(255, 255, 255, 0.7)', fontWeight: 'bold' }}>
          순수익
        </Typography>
        <Typography variant="h6" fontWeight="bold" color="#fff">
          {formatCurrency(totalProfit)}
        </Typography>
      </Box>

      {/* 손익률 */}
      <Box
        sx={{
          backgroundColor: '#FF9800',
          border: '1px solid #e0e0e0',
          borderRadius: 2,
          p: 2,
          color: '#fff',
        }}
      >
        <Typography variant="body2" sx={{ mb: 1, color: 'rgba(255, 255, 255, 0.7)', fontWeight: 'bold' }}>
          손익률
        </Typography>
        <Typography variant="h6" fontWeight="bold" color="#fff">
          {profitMargin >= 0 ? '+' : ''}
          {profitMargin.toFixed(0)}%
        </Typography>
      </Box>
    </Box>
  );
}

